export default {
  bind: function (el) {
    const regx= /\D+/
    const input = el.getElementsByTagName('input')[0] || el
    input.onkeyup = function (e) {
      input.value = input.value.replace(regx, '')
      trigger(input, 'input')
    }
    input.onblur = function (e) {
      input.value = input.value.replace(regx, '')
      trigger(input, 'input')
    }
  }
}
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}



// WEBPACK FOOTER //
// ./src/assets/plugin/directives/numberOnly.js